'use client';

import { handlers } from '@root/__mocks__/msw/handlers';
import type { PropsWithChildren } from 'react';

import { isMswOn, isServer } from '@/constants/common';

if (!isServer && isMswOn && process.env.NODE_ENV === 'development') {
	import('msw').then(({ setupWorker }) => {
		setupWorker(...handlers).start({ onUnhandledRequest: 'bypass' });
	});
}

export default function MSWInitializer({ children }: PropsWithChildren) {
	return <>{children}</>;
}
